import { SubjectData } from 'shell/models/person';
import { DateTime } from 'luxon';
import { AccordionVoidMarriage } from 'shell/components/shared/sipo-person-form/new-person';

export const transformVoidMarriage = (person: SubjectData): AccordionVoidMarriage | undefined => {
  const originReturnData: AccordionVoidMarriage | undefined = person.annullamentoMatrimonio
    ? {
        number: person.annullamentoMatrimonio?.sentenza?.numero,
        eventDate: person.annullamentoMatrimonio?.sentenza?.data
          ? DateTime.fromISO(person.annullamentoMatrimonio?.sentenza?.data)
          : null,
        validityDate: person.annullamentoMatrimonio?.sentenza?.dataValidita
          ? DateTime.fromISO(person.annullamentoMatrimonio?.sentenza?.dataValidita)
          : null,
        courtType: person.annullamentoMatrimonio?.sentenza?.tipoTribunale || '',
        authority: person.annullamentoMatrimonio?.sentenza?.autorita || '',
        type: person.annullamentoMatrimonio?.tipoCessazione || '',
        // paper
        location:
          person.annullamentoMatrimonio?.attoAnnullamentoMatrimonio?.comuneRegistrazione
            ?.descrizioneLocalita || '',
        year: person.annullamentoMatrimonio?.attoAnnullamentoMatrimonio?.anno || '',
        province:
          person.annullamentoMatrimonio?.attoAnnullamentoMatrimonio?.comuneRegistrazione
            ?.siglaProvinciaIstat || '',
        documentNumber: person.annullamentoMatrimonio?.attoAnnullamentoMatrimonio?.numeroAtto || '',
        portion: person.annullamentoMatrimonio?.attoAnnullamentoMatrimonio?.parte || '',
        range: person.annullamentoMatrimonio?.attoAnnullamentoMatrimonio?.serie || '',
        regVol: person.annullamentoMatrimonio?.attoAnnullamentoMatrimonio?.volume || '',
        office: person.annullamentoMatrimonio?.attoAnnullamentoMatrimonio?.ufficioMunicipio || '',
        documentDate: person.annullamentoMatrimonio?.attoAnnullamentoMatrimonio?.dataFormazioneAtto
          ? DateTime.fromISO(
              person.annullamentoMatrimonio?.attoAnnullamentoMatrimonio?.dataFormazioneAtto
            )
          : null,
        transcript:
          person.annullamentoMatrimonio?.attoAnnullamentoMatrimonio?.trascritto === '1'
            ? true
            : false,
      }
    : undefined;

  return originReturnData;
};
